export const reservas = {
    // Filtr, z którym lista przychodzi z kafelków panelu
    filtroLlegadas: {
        today: `Przyjazdy dzisiaj`,
        tomorrow: `Przyjazdy jutro`,
        this_week: `Przyjazdy w tym tygodniu`,
        month: `Przyjazdy w tym miesiącu`,
        upcoming: `Nadchodzące przyjazdy`,
    },
    filtroSalidas: {
        today: `Wyjazdy dzisiaj`,
    },
    quitarFiltro: `Usuń filtr`,
    // Pobyt sprzedany na godziny, zapisany jako rezerwacja
    rapida: `Szybka`,
    p1:`Lista rezerwacji`,
    p2:`Lista rezerwacji zarejestrowanych na platformie`,
    p3:`Więcej akcji`,
    p4:`Zaplanuj check-in`,
    p5:`Dziś`,
    p6:`Kod rezerwacji`,
    p7:`Imię`,
    p8:`E-mail`,
    p9:`Data check-inu`,
    p10:`Depozyt`,
    p11:`Liczba gości`,
    p12:`Status: `,
    p13:`Kwota: `,
    p14:`Status: `,
    p15:`Oczekuje`,
    p16:`Zakończone`,

    p17:`Więcej akcji`,
    p18:`Importuj rezerwacje`,
    p19:`Pobierz szablon Excel, uzupełnij dane swoich rezerwacji i prześlij go, aby utworzyć wiele rezerwacji naraz.`,

    p20:`Zaplanowany check-in`,
    p21:`Szczegółowe informacje o zaplanowanym check-inie`,
    p22:`Status: `,
    p23:`Opłacone`,
    p24:`Oczekuje na płatność`,
    p25:`Zmień status płatności`,
    p26:`Osoba odpowiedzialna za check-in`,
    p27:`Wyślij check-in online`,
    p28:`Wysyłanie linku do check-inu...`,
    p29:`Automatycznie wysyłaj gościom link do check-inu online`,
    p30:`Tydzień przed check-inem`,
    p31:`72 godziny przed check-inem`,
    p32:`48 godzin przed check-inem`,
    p33:`24 godziny przed check-inem`,
    p34:`Zapisz zmiany`,
    p35:`Data check-inu`,
    p36:`Data check-outu`,
    p37:`Zarejestrowani goście`,
    p38:`Lista zakończonych check-inów`,
    p39:`Imię`,
    p41:`Nazwisko`,
    p42:`Data check-inu`,
    p43:`E-mail`,
    p44:`Proces`,
    p45:`Zeskanowany`,
    p46:`Ręczny`,
    p47:`Ręczny przez operatora`,
    p48:`Telefon`,
    p49:`Brak zarejestrowanych check-inów`,

    p50:`Status płatności rezerwacji`,
    p51:`Ręcznie zmień status płatności rezerwacji.`,
    p52:`Wybierz jedną z opcji`,
    p53:`Oczekuje`,
    p54:`Opłacone`,
    p55:`Anuluj`,
    p56:`Zmień status`,
    p57:`Nieokreślony`,
    p58:`Zakończone`,
    p59:`Nie ma jeszcze zarejestrowanych rezerwacji`,
    p60:`Zaplanowane check-iny`,
    p61:`Zmiany zostały zapisane`,
    p62:`Czy wysłać link do check-inu?`,
    p63:`Wyślij link`,
    p64:`Anuluj`,
    p65:`Prośba o check-in została wysłana`,

    p66:`Nie znaleziono obiektu ani użytkownika.`,
    p67:`Błąd podczas generowania tokenu`,
    p68:`Błąd połączenia z kanałem. Spróbuj ponownie.`,
    p69:`Dostępność i ceny`,
    p70:`Zarządzaj dostępnymi dniami i cenami w swoim zakwaterowaniu`,
    p71:`Aby włączyć tę funkcję, potrzebny jest aktywny plan. Od razu zobaczysz dostępność swojego zakwaterowania, dostosujesz ceny do sezonu lub wydarzeń specjalnych i będziesz zarządzać wszystkim z jednego miejsca.`,
    p72:`Po anulowaniu tej rezerwacji daty staną się dostępne we wszystkich podłączonych portalach`,
    p73:`Anuluj rezerwację`,
    p74:`Rezerwacja została anulowana`,
    p75:`Rezerwacja: `,
    p76:` została anulowana.`,
    p77:`Nie można rezerwować w zablokowanych terminach.`,
    p78:`Sprawdź wybrane daty`,
    p79:`Trzeba wybrać co najmniej jedną noc dla rezerwacji.`,
    p80:`Wybrane daty nie są dostępne.`,
    p81:`Przypomnienia`,
    p82:`Zarządzaj przypomnieniami dla swoich gości`,
    p83:`Utwórz nowe przypomnienie`,
    p84:`Dzień`,
    p85:`Godzina`,
    p86:`Opis`,
    p87:`Usuń przypomnienie`,
    p88:`Nie znaleziono przypomnień`,
    p89:`Czy na pewno usunąć to przypomnienie?`,
    p90:`Zapisane dane zostaną utracone`,
    p91:`Usuń przypomnienie`,
    p92:`Przypomnienie zostało usunięte`,
    p93:`Krok pierwszy:`,
    p94:`Wybierz kraj, w którym masz rezerwacje, i pobierz szablon do uzupełnienia danych.`,
    p95:`Pobierz szablon`,
    p96:`Krok drugi:`,
    p97:`Prześlij te same pobrane szablony z uzupełnionymi danymi.`,
    p98:`Importuj`,
    p99:`Aby kontynuować import, trzeba przesłać szablon`,
    p100:`Proces został zakończony pomyślnie`,
    p101:`Błąd podczas importu`,
    p102:`Dostępny`,
    p103:`Zajęty`,
    p104:`Sprzątanie`,
    p105:`Konserwacja`,
    p106:`Błąd podczas anulowania rezerwacji`,
    p107:`Błąd podczas odświeżania widoku po anulowaniu`,
    p108:`Nie udało się otworzyć zmiany pokoju. Nieprawidłowa rezerwacja.`,
    p109:`Nie udało się rozpoznać bieżącego pokoju.`,
    p110:`Dostępność została zaktualizowana`,
    p111:`Kalendarz hotelowy`,
    p112:`Zarządzaj rezerwacjami wizualnie i zachowaj pełną kontrolę nad dostępnością swojego hotelu.`,
    p113:`Zmień dostępność`,
    p114:`Utwórz rezerwację`,
    p115:`Wstrzymane rezerwacje nie będą wysyłane automatycznie`,
    p116:`Dla tej rezerwacji zostanie włączone automatyczne wysyłanie`,
    p117:`Wstrzymaj`,
    p118:`Aktywuj`,
    p119:`rezerwację`,
    p120:`Tak`,
    p121:`Rezerwacja została wstrzymana`,
    p122:`Proces został zakończony pomyślnie`,
    p123:`Rezerwacja została aktywowana`,
    p124:`Zsynchronizowane i ręcznie utworzone rezerwacje`,
    p125:`Nieprawidłowa data`,
    p126:`Nieprawidłowa data`,
    p127:`Zaproszenie do check-inu zostanie wysłane: `,
    p128:`Rezerwacja wstrzymana`,
    p129:`Rezerwacja anulowana`,
    p130:`Zakończone`,
    p131:`Tutaj pojawią się wszystkie Twoje rezerwacje wraz ze szczegółami każdego check-inu i gościa. Gdy otrzymasz pierwszą rezerwację, zobaczysz ją właśnie tutaj.`,
    p132:`Wybrany obiekt`,
    p133:`Wiele`,
    p134:`Miesięcznie`,
    p135:`Zamknięte`,
    p136:`Daty zostały zaktualizowane`,
    p137:`Błąd podczas wczytywania danych obiektu`,
    p138:`Wybrane daty nie są dostępne. Konflikt powodują rezerwacje lub zamknięte terminy.`,
    p139:`Rezerwacja została utworzona`,
    p140:`Zakres`,
    p141:`został pomyślnie zamknięty`,
    p142:`Błąd podczas blokowania dat`,
    p143:`Błąd podczas usuwania zamkniętych terminów`,
    p144:`Ceny zostały zaktualizowane`,
    p145:`Błąd podczas aktualizacji cen`,
    p146:`Czy na pewno anulować tę rezerwację?`,
    p147:`Potwierdź anulowanie`,
    p148:`Tak, anuluj`,
    p149:`Nie`,
    p150:`Rezerwacja została anulowana`,
    p151:`Błąd podczas wczytywania obiektów`,
    p152:`Nowa rezerwacja dodana do kalendarza`,
    p153:`Ta rezerwacja pochodzi z zewnętrznego kanału (OTA). Nie zaleca się anulowania jej bezpośrednio w tym systemie. Prosimy skontaktować się z gościem i poprosić o anulowanie rezerwacji w kanale źródłowym.`,
    p154:`Rezerwacja OTA - anulowanie niedozwolone`,
    p155:`Rozumiem`,
    p156:`Błąd podczas przetwarzania żądania`,
    p157:`Link został skopiowany`,
    p158:`Skopiowano!`,
    p159:`Wystąpił błąd podczas kopiowania linku`,
    p160:`Błąd`,
    p161:`Wyślij check-in do osoby odpowiedzialnej za rezerwację`,
    p162:`Wyślij check-in`,
    p163:`Wyślij`,
    p164:`Błąd podczas wczytywania rezerwacji`,
    p165:`Informacje o check-inie`,
    p166:`Wyślij prośbę o check-in`,
    p167:`Wszystkie rezerwacje`,
    p168:`Nadchodzące rezerwacje`,
    p169:`Anulowane rezerwacje`,
    p170:`Goście`,
    p171:`Data check-inu`,
    p172:`Check-in`,
    p173:`Zarezerwowane`,
    p174:`Overbooking`,
    p175:`Anulowane`,
    p176:``,
    p177:``,
    p178:``,
    p179:``,
    p180:``,
    p181:``,
    p182:``,
    p183:``,
}
